import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Loader from "../shared/Loader";
import { validatePassword } from "../../utils/validators";
import { authService } from "../../services/authService";
import { useNotification } from "../toster-notification/NotificationContext";

import { PadlockIcon } from "../../assets/icons";


const ResetPasswordPage: React.FC = () => {

    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [password, setPassword] = useState<string>("");
    const [passwordError, setPasswordError] = useState<string | null>(null);
    const [confirmPassword, setConfirmPassword] = useState<string>("");
    const [confirmPasswordError, setConfirmPasswordError] = useState<string | null>(null);

    const [loading, setLoading] = useState<boolean>(false);

    const navigate = useNavigate();
    const { notify } = useNotification();

    const handleResetPassword = async () => {

        setConfirmPasswordError(null);

        const validateResult = validatePassword(password);

        if(validateResult !== null){
            setPasswordError(validateResult);
            return;
        } else {
            setPasswordError(null);
        }

        if (password===null) {
            return;
        }

        if (password !== confirmPassword) {
            setConfirmPasswordError("Passwords do not match");
            return;
        }

        setLoading(true);
        try {

            if (!token) {
                setLoading(false);
                notify("error", "Invalid or missing token");
                return;
            }

            const response = await authService.resetPassword({ token, newPassword: password });

            if (response.success) {
                notify("success", response.message);
                navigate("/login");
            }

        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                notify("error", error.response.data.message);
            } else {
                notify("error", "An error occurred. Please try again.");
            }
            console.error("Error resetting password:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="reset-password-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="reset-password-wrapper">
                    <div className="form-block-6 w-form">
                        <div className="small-box-div">
                            <img src={PadlockIcon} loading="lazy" alt="" className="icon-size-28" />
                        </div>
                        <div className="div-block-28">
                            <div className="_2rem bold center">Change password</div>
                        </div>
                        <form className="form-7">

                            <div className="form-input-box">
                                <label className="label-input">New password</label>
                                <input className="form-input w-input" type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                {passwordError && <div className="error-text">{passwordError}</div>}
                            </div>

                            <div className="form-input-box">
                                <label className="label-input">Repeat new password</label>
                                <input className="form-input w-input" type="password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                {confirmPasswordError && <div className="error-text">{confirmPasswordError}</div>}
                            </div>

                            {loading ?
                                <Loader fullscreen={false} />
                                :
                                <div className="button-primary" onClick={handleResetPassword} >
                                    <div>Change password</div>
                                </div>
                            }

                        </form>
                        <div className="link-text grey" onClick={() => navigate("/login")}>Back to login</div>
                    </div>
                </div>
            </div>
        </section>

    );
};

export default ResetPasswordPage;